import { ListSubheader, TextField } from '@mui/material';

type SelectSearchHeaderProps = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
};

export const SelectSearchHeader = ({
  placeholder,
  value,
  onChange,
  autoFocus,
}: SelectSearchHeaderProps) => {
  return (
    <ListSubheader onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
      <TextField
        autoFocus={autoFocus}
        placeholder={placeholder}
        fullWidth
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
    </ListSubheader>
  );
};

export default SelectSearchHeader;
